import { gql } from "@apollo/client";

export const GET_MYLIBRARY_FILES = gql`
query getClassroomLibrary($cId: UUID!) {
  allMylibraries(filter: {cId: {equalTo: $cId}}, orderBy: L_TYPE_ASC) {
    nodes {
      lId
      lType
      lAvatarUrl
      lTypeInfo
    }
  }
}
`;

export const GET_SUBJECTS = gql`
query getConfiguredSubjects($cId: UUID) {
  getConfiguredSubjects(cId: $cId) {
    sjId
    sjName
    sjOriginalName
    sjColorCode
    subjectAvatarUrl
    sessionExists
  }
}
`;

export const GET_NOTIFICATIONS = gql`
query getNotificationCount {
  notifyUser {
    Announcement
    Calender
    Workshop
  }
}`;

export const GET_CLASSROOM_UPDATES = gql`
  query getClassroomUpdates($cId: UUID!) {
    getClassroomUpdates(cId: $cId) {
      quiz {
        nodes {
          isQuizExist
          subjectId
        }
        totalCount
      }
      mylibrary {
        nodes {
          lId
          lType
          subjectIds
          feedexist
        }
        totalCount
      }
      ebooks {
        nodes {
          subjectId
          feedexist
          typeNames
        }
        totalCount
      }
      assignments {
        nodes {
          isAssignmentExist
          subjectId
        }
        totalCount
      }
    }
  }
`;

export const READ_CLASSROOMUPDATES = gql`
  mutation insertUserFeed($fId: UUID!, $uId: UUID!) {
    createUserFeed(input: { userFeed: { uId: $uId, fId: $fId } }) {
      clientMutationId
    }
  }
`;

export const GET_CHAT_INDICATION = gql `
query getAllChatCount($cId: UUID!) {
  getAllChatCount(cId: $cId)
}
`

export const GET_SUBJECTS_BY_CLASSROOM = gql`
  query GetSubjectsByClassroom($classroomId: UUID!) {
    allSubjects(
      filter: {
        classroomSubjectsBySjId: { some: { cId: { equalTo: $classroomId } } }
      }
    ) {
      nodes {
        deletedAt
        subjectAvatarUrl
        sjColorCode
        sjOriginalName
        sjId
        sjName
      }
    }
  }
`;